<template>
  <v-card
    class="rounded-lg"
  >
    <v-card-title>
      {{ tituloCard }}

      <v-spacer></v-spacer>

      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      height="100%"
      :headers="headers"
      :items="items"
      :search="search"
      :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
      sortBy="divida.descricao"
      class="elevation-1"
    >
      <!-- status -->
      <template v-slot:[`item.id`]="{ item }">
        <span
          :class="{'botao_1--text': item.status_pago.nome === 'Pago' || item.status_pago.nome === 'Recebido'}"
        >
          {{ item.id }}
        </span>
      </template>

      <!-- descricao -->
      <template v-slot:[`item.divida.descricao`]="{ item }">
        <span
          :class="{'botao_1--text': item.status_pago.nome === 'Pago' || item.status_pago.nome === 'Recebido'}"
        >
          {{ item.divida.descricao }}
        </span>
      </template>

      <!-- valor parcela -->
      <template v-slot:[`item.valor_parcela`]="{ item }">
        <span
          :class="{'botao_1--text': item.status_pago.nome === 'Pago' || item.status_pago.nome === 'Recebido'}"
        >
          {{ item.valor_parcela }}
        </span>
      </template>

      <!-- Quantidade de parcelas -->
      <template v-slot:[`item.divida.num_parcelas`]="{ item }">
        <span
          :class="{'botao_1--text': item.status_pago.nome === 'Pago' || item.status_pago.nome === 'Recebido'}"
        >
          {{ item.divida.num_parcelas }}
        </span>
      </template>

      <!-- status -->
      <template v-slot:[`item.status_pago`]="{ item }">
        <v-select
          v-model="item.status_pago.nome"
          :items="status"
          item-text="nome"
          item-value="nome"
          :class="item.status_pago.nome==='Pago' ||
                  item.status_pago.nome==='Recebido'
                  ? 'botao_1 rounded-lg px-2 my-1' :
                  'botao_2 rounded-lg px-2 my-1'"
          dense
          dark
          @change="atualizar_status_parcela(item)"
        ></v-select>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        
        <!-- Atualizar -->
        <v-dialog transition="dialog-top-transition" max-width="600">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              color="botao_1"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click="formatar_form(item)"
            >
              mdi-pencil
            </v-icon>
            
          </template>
  
          <template v-slot:default="dialog">
            <v-card class="rounded-lg">
              <v-toolbar
                dark
                class="rounded-lg"
                color="primary"
              >
                Atualizar::{{ form.divida.id }}
              </v-toolbar>
              <br>
  
              <v-card-text>
                <v-form ref="form">
                  <!-- Descrição -->
                  <v-text-field
                    v-model="form.divida.descricao"
                    :counter="100"
                    label="Descrição"
                    :rules="[() => !!form.divida.descricao
                                   || 'A descrição é obrigatória',
                             () => form.divida.descricao.length<=100
                                   || 'A descrição deve conter no máximo 100 caracteres',]"
                    required
                  ></v-text-field>
                  
                  <!-- Data -->
                  <v-text-field
                    type="month"
                    label="Data"
                    :value="formata_data(form.data)"
                    :rules="[v => !!v || 'A data é obrigatória']"
                    disabled
                  ></v-text-field>
              
                  <!-- Tipo -->
                  <v-select
                    v-model="form.divida.tipo"
                    :items="tipos"
                    label="Tipo"
                    :rules="[v => !!v || 'O tipo é obrigatório']"
                    required
                  ></v-select>
              
                  <!-- Valor Parcela -->
                  <v-currency-field
                    v-model="form['valor_parcela']"
                    type="number"
                    label="Valor Parcela"
                    :rules="[v => !!v || 'O valor da parcela é obrigatório']"
                    v-bind="currency_config"
                    :error-messages="errors.price"
                    required
                  ></v-currency-field>
  
                  <!-- Quantidade de Parcelas -->
                  <v-text-field
                    v-model="form['divida']['num_parcelas']"
                    type="number"
                    label="Quantidade de Parcelas"
                    :rules="[v => !!v || 'A quantidade de parcelas é obrigatória',
                             v => v>0 || 'O numeros de parcelas deve ser maior do que 0']"
                    disabled
                  ></v-text-field>
                </v-form>
              </v-card-text>
  
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  @click="dialog.value = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  text
                  @click="atualizar(dialog)"
                >
                  Atualizar
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>


        <!-- deletar -->
        <v-dialog transition="dialog-top-transition" max-width="600">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              color="botao_1"
              v-bind="attrs"
              v-on="on"
            >
              mdi-delete
            </v-icon>
            
          </template>
  
          <template v-slot:default="dialog">
            <v-card class="rounded-lg">
              <v-toolbar
                dark
                class="rounded-lg"
                color="primary"
              >
                Remover::{{ item.divida.id }}
              </v-toolbar>
  
              <v-card-text class="mt-10">
                <h1>
                  Tem certeza que deseja remover?
                </h1>

                <br>

                <h2 v-if="item.divida.num_parcelas > 1">
                  Obs.: Será removido as {{ item.divida.num_parcelas }} parcelas da {{ item.divida.tipo }} de código {{ item.id }}
                </h2>
              </v-card-text>
  
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  @click="dialog.value = false"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  text
                  @click="remover(item, dialog)"
                >
                  Remover
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: "TabelaComp",

  data: () => ({
    search: "",
    form: {},
    tipos: ['entrada', 'saida'],
    teste: 0,
    errors: {},
    currency_config: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: ' #',
      precision: 2,
      masked: false,
      allowBlank: false,
      min: Number.MIN_SAFE_INTEGER,
      max: Number.MAX_SAFE_INTEGER
    }
  }),

  props: {
    tituloCard: String,
    items: Array,
    headers: Array,
    tipo: String,
    status: Array,
  },

  created() {
    this.getStatusParcela(this.tipo);
  },

  methods: {
    ...mapActions([
      'removerAction',
      'atualizarAction',
      'getStatusParcelaAction',
      'atualizarStatusParcelaAction',
    ]),

    atualizar(dialog) {
      if (this.$refs.form.validate()) {
        this.atualizarAction(this.form);
        dialog.value=false;
      }
    },

    getStatusParcela(tipo) {
      this.getStatusParcelaAction(tipo);
    },

    atualizar_status_parcela(item) {
      this.atualizarStatusParcelaAction(item)
    },

    remover(item, dialog) {
      this.removerAction(item)
      dialog.value = false
    },

    formata_data(data) {
      const data_formatada = data.slice(6,)+'-'+data.slice(3,5);
      return data_formatada;
    },

    formatar_form(item) {
      this.form = {
        'id': item['id'],
        'data': item['data'],
        'valor_parcela': item['valor_parcela'].slice(3).replace('.', '').replace(',', '.'),
        'divida': item['divida']
      }
    }
  }
};
</script>
